<template>
  <b-tabs pills vertical>
    <b-tab v-for="option in value" :key="option.id">
      <template v-slot:title>{{ option.option }} - {{ option.name }}</template>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Name">
            <b-form-input type="text" class="form-control" v-model="option.name" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-btn size="sm" variant="primary" @click="saveOption(option)">Save</b-btn>
          <b-btn class="ml-1" size="sm" variant="danger" @click="delOption(option.id)">Delete</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr />
          <b-form-group label="Routes">
            <menu-option-routes :optionId="option.id" :menuId="option.menuId" v-model="option.routes" @routeUpdate="routeUpdate" @sortUpdate="sortUpdate"></menu-option-routes>
          </b-form-group>
        </b-col>
      </b-row>
    </b-tab>
    <template #tabs-end>
      <b-nav-item variant="success" role="presentation" @click.prevent="addOption" href="#"><b>+ Add</b></b-nav-item>
    </template>
  </b-tabs>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuOptionRoutes from './MenuOptionRoutes.vue'

export default {
  components: { MenuOptionRoutes },
  name: 'MenuOptions',
  props: [ 'value' ],
  computed: {
    ...mapGetters({
      account: 'global/account',
      extensions: 'account/extensions'
    })
  },
  data () {
    return {
    }
  },
  methods: {
    async saveOption (option) {
      const menuOption = {
        id: option.id,
        name: option.name
      }

      await this.$axios.put(`/v1/menus/options/${option.id}`, menuOption)

    },
    addOption () {
      this.$bus.$emit('modal:addMenuOption')
    },
    async delOption (optionId) {
      await this.$axios.delete(`/v1/menus/options/${optionId}`)
    },
    routeUpdate (type, index, data) {
      if (type === 'save') {
        if (index >= 0) {
          this.$set(this.value.routes, index, data)
        }
      } else if (type === 'delete') {
        this.value.routes.splice(index, 1)
      }
    },
    sortUpdate (routes) {
      this.value.routes = routes
    },
  },
  created () {

  }
}
</script>
